export enum Validator {
  required = 'required',
  minLength = 'minlength',
  maxLength = 'maxlength',
  min = 'min',
  max = 'max',
  email = 'email',
  pattern = 'pattern',
  phone = 'phone'
}
